import SyncIcon from "@mui/icons-material/Sync";
import {
  ArrowdownIcon,
  ArrowupIcon,
  DeleteIcon,
  EditsquareIcon,
  InfoIcon,
  PageCopyIcon,
  PageHiddenIcon,
  RefreshIcon,
  SettingsIcon,
  VisibilityIcon,
} from "@platformx/shared/static-assets";

export const iconsSet = [
  {
    id: "prelemInfo",
    tooltipId: "Prelem Info",
    Icon: () => <img src={InfoIcon} alt='icon' className='icon' />,
    disabledIcon: () => <img src={InfoIcon} alt='icon' className='hideIcon' />,
  },
  {
    id: "edit",
    tooltipId: "Edit",
    Icon: () => <img src={EditsquareIcon} alt='icon' className='icon' />,
    disabledIcon: () => <img src={EditsquareIcon} alt='icon' className='hideIcon' />,
  },
  {
    id: "show",
    tooltipId: "Hide",
    Icon: () => <img src={VisibilityIcon} alt='icon' className='icon' />,
    disabledIcon: () => <img src={VisibilityIcon} alt='icon' className='hideIcon' />,
  },
  {
    id: "hide",
    tooltipId: "Show",
    Icon: () => <img src={PageHiddenIcon} alt='icon' className='icon' />,
    disabledIcon: () => <img src={PageHiddenIcon} alt='icon' className='hideIcon' />,
  },
  {
    id: "prelemSetting",
    tooltipId: "Settings",
    Icon: () => <img src={SettingsIcon} alt='icon' className='icon' />,
    disabledIcon: () => <img src={SettingsIcon} alt='icon' className='hideIcon' />,
  },
  {
    id: "copy",
    tooltipId: "Duplicate",
    Icon: () => <img src={PageCopyIcon} alt='icon' className='icon' />,
    disabledIcon: () => <img src={PageCopyIcon} alt='icon' className='hideIcon' />,
  },
  {
    id: "up",
    tooltipId: "Move Up",
    Icon: () => <img src={ArrowupIcon} alt='icon' className='icon' />,
    disabledIcon: () => <img src={ArrowupIcon} alt='icon' className='hideIcon' />,
  },
  {
    id: "down",
    tooltipId: "Move Down",
    Icon: () => <img src={ArrowdownIcon} alt='icon' className='icon' />,
    disabledIcon: () => <img src={ArrowdownIcon} alt='icon' className='hideIcon' />,
  },
  {
    id: "reset",
    tooltipId: "Undo",
    Icon: () => <img src={RefreshIcon} alt='icon' className='icon' />,
    disabledIcon: () => <img src={RefreshIcon} alt='icon' className='hideIcon' />,
  },
  {
    id: "sync",
    tooltipId: "Sync Structure Data",
    Icon: () => (
      <SyncIcon
        className='icon'
        sx={{
          width: "20px",
          height: "20px",
          color: "#ffffff",
          transition: "color 0.3s",
          "&:hover": {
            color: "gray",
          },
        }}
      />
    ),
  },
  {
    id: "delete",
    tooltipId: "Delete",
    Icon: () => <img src={DeleteIcon} alt='icon' className='icon' />,
    disabledIcon: () => <img src={DeleteIcon} alt='icon' className='hideIcon' />,
  },
];
